import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PersDataApiFrom } from '@api-gen/models/pers-data-api-from';
import { LanguageApiRoaming } from '@api-roaming/models/language-api-roaming';
import { BurgerMenuModalComponent } from '@shared/components/layout/burger-menu-modal/burger-menu-modal.component';
import { NavItemComponent } from '@shared/components/layout/nav-item/nav-item.component';
import { NavbarComponent } from '@shared/components/layout/navbar/navbar.component';
import { ToolbarComponent } from '@shared/components/layout/toolbar/toolbar.component';
import { UserMenuComponent } from '@shared/components/layout/user-menu/user-menu.component';
import { LanguageState } from '@core/localization/language.state';
import { NavItemModel, NavItemTranslateCodes } from '@core/models/nav-item.model';
import { SettingsAsObject } from '@core/models/settings.model';
import { NavItemAccessPipe } from '@core/pipes/nav-item-access.pipe';
import { RouteEntity } from '@core/router/router.entity';
import { AppState } from '@core/state/app.state';
import { UserState } from '@core/state/user.state';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        TranslateModule,
        ToolbarComponent,
        NavbarComponent,
        NavItemAccessPipe,
        NavItemComponent,
        AsyncPipe,
        UserMenuComponent,
    ],
})
export class HeaderComponent {
    readonly #userState: UserState = inject(UserState);
    readonly #appState: AppState = inject(AppState);
    readonly #dialog: MatDialog = inject(MatDialog);
    readonly #languageState: LanguageState = inject(LanguageState);

    public readonly loggedIn$: Observable<boolean> = this.#userState.isAuthorized$;
    public readonly languages$: Observable<LanguageApiRoaming[]> = this.#languageState.languages$;
    public readonly currentLang$: Observable<string> = this.#languageState.language$;
    public readonly settings$: Observable<SettingsAsObject> = this.#appState.settings$;
    public readonly person$: Observable<PersDataApiFrom> = this.#userState.profile$;

    public readonly navItemList: NavItemModel[] = [
        {
            path: [RouteEntity.Root, RouteEntity.Tickets],
            title: NavItemTranslateCodes.get(RouteEntity.Tickets),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Services],
            title: NavItemTranslateCodes.get(RouteEntity.Services),
        },
        {
            path: [RouteEntity.Root, RouteEntity.History],
            title: NavItemTranslateCodes.get(RouteEntity.History),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Person],
            title: NavItemTranslateCodes.get(RouteEntity.Person),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Map],
            title: NavItemTranslateCodes.get(RouteEntity.Map),
        },
        {
            path: [RouteEntity.Root, RouteEntity.Coupon],
            title: NavItemTranslateCodes.get(RouteEntity.Coupon),
        },
    ];

    public onSwitchLang(lang: string): void {
        this.#languageState.setCurrentLanguage(lang);
        window.location.reload();
    }

    public openBurgerMenu(): void {
        this.#dialog.open(BurgerMenuModalComponent, {
            id: BurgerMenuModalComponent.DIALOG_ID,
        });
    }
}
